import { cn } from 'noddi-ui-common';

const pulseAnimation = `
  @keyframes pulse {
    0% {transform: scale(0.1, 0.1); opacity: 0.0;}
    50% {opacity: 1.0;}
    100% {transform: scale(1.2, 1.2); opacity: 0.0;}
  }
`;

export const LiveMarker = ({ className }: { className?: string }) => (
  <div className={cn('relative size-[15px] min-h-[15px] min-w-[15px] rounded-full bg-primary', className)}>
    <div
      className='absolute left-[-5px] top-[-5px] size-[25px] rounded-full border-[3px] border-primary'
      style={{
        animation: 'pulse 1s ease-out infinite'
      }}
    />
    <style>{pulseAnimation}</style>
  </div>
);
